<template>
  <div class="container" v-loading="loading">
    <div class="card" v-if="error">
      <el-alert type="error" :closable="false" title="加载失败" :description="error" />
    </div>
    <div class="card" v-else>
      <p class="hint">正在跳转到测评结果…</p>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import axios from 'axios'
import authManager from '@/utils/auth'

export default {
  name: 'H5ExamResultView',
  setup() {
    const route = useRoute()
    const router = useRouter()
    const loading = ref(true)
    const error = ref('')

    const resultId = ref(route.query.resultId || '')
    const authCode = ref(route.query.authCode || '')
    const legacyToken = ref(route.query.token || '')

    async function resolveAccessToken() {
      if (authCode.value) {
        const resp = await axios.get('/api/v1/user/oauth/exchange', {
          params: { code: authCode.value }
        })
        if (resp.data?.code === 200 && resp.data.data?.accessToken) {
          return resp.data.data
        }
        throw new Error(resp.data?.message || '授权码兑换失败')
      }
      if (legacyToken.value) {
        return { accessToken: legacyToken.value, accessExpire: 7200 }
      }
      throw new Error('缺少 resultId 或 authCode')
    }

    onMounted(async () => {
      try {
        if (!resultId.value) {
          throw new Error('缺少 resultId')
        }

        let loginData = await resolveAccessToken()

        try {
          const resp = await axios.post(
            '/api/v1/user/keeplogin',
            {},
            {
              headers: {
                Authorization: `Bearer ${loginData.accessToken}`,
                'Content-Type': 'application/json'
              }
            }
          )
          if (resp.data?.code === 200 && resp.data.data) {
            loginData = resp.data.data
          }
        } catch (e) {
          console.warn('keeplogin after H5 auth failed, use token only:', e)
        }

        await authManager.handleLoginSuccess(loginData)
        await router.replace(`/exam/result/${resultId.value}`)
      } catch (e) {
        const msg = e.response?.data?.message || e.message || String(e)
        error.value = msg.includes('404') ? '登录接口未就绪，请确认后端已部署 oauth/exchange' : msg
      } finally {
        loading.value = false
      }
    })

    return { loading, error }
  }
}
</script>

<style scoped>
.container { max-width: 600px; margin: 40px auto; padding: 20px; }
.card { background: #fff; border-radius: 8px; padding: 24px; box-shadow: 0 2px 12px rgba(0,0,0,.08); }
.hint { color: #666; text-align: center; }
</style>
